<template>
  <div class="container">
    <Step :active-step="4">
      <template slot="step">
        ÜRÜN GÖRSELLERİ
      </template>
    </Step>
    <section>
      <div class="header">
        Ürün Görseli Yükleyiniz
      </div>
      <div
        class="row"
      >
        <button
          class="btn btn-dark"
          @click="onInputFile"
        >
          <img :src="`${$root.cdnUrl}assets/icon-picture.svg`">
          <span>Galeriden Görsel Yükle</span>
          <img :src="`${$root.cdnUrl}assets/icon-arrow-right.svg`">

          <input
            id="gallery"
            class="fileInput"
            type="file"
            ref="fileInput"
            accept="application/pdf,image/png,image/jpg,image/jpeg"
            @change="onChangeImages"
          >
        </button>
      </div>
      <div class="row">
        <button
          class="btn btn-dark"
          :disabled="!$root.permissions.camera"
          @click="onInputCamera"
        >
          <img :src="`${$root.cdnUrl}assets/icon-camera.svg`">
          <span>Fotoğraf Çekerek Yükle</span>
          <img :src="`${$root.cdnUrl}assets/icon-arrow-right.svg`">

          <input
            id="camera"
            class="fileInput"
            type="file"
            ref="fileCamera"
            accept="capture=camera"
            @change="onChangeImages"
          >
        </button>
      </div>
      <div
        v-if="!$root.permissions.camera"
        class="text-info"
      >
        Bu seçeneği kullanamıyorsanız;
        telefonunuzun ayarlar bölümünden Trendyol Satıcı Paneliniz için kamera erişimize izin vermeniz gerekmektedir!
      </div>
      <div
        class="row"
        v-if="hasImagesInGallery"
      >
        <button
          class="btn btn-success"
          @click="openMediaGallery"
        >
          <span>Trendyol Galerinden Görsel Ekle</span>
          <img :src="`${$root.cdnUrl}assets/icon-add-circle.svg`">
        </button>
      </div>
    </section>
    <section v-if="formData.productImages.length">
      <div class="header">
        Eklediğiniz Görseller
      </div>
      <div class="row">
        <div class="uploaded-wrapper">
          <ul class="images">
            <li
              v-for="(image, k) in getProductImages"
              :key="k"
              class="image"
            >
              <div
                class="image-wrapper"
              >
                <div
                  class="close-container"
                  @click="removeProductImage(k)"
                >
                  <img :src="`${$root.cdnUrl}assets/icon-close-gray.svg`">
                </div>
                <img :src="image.filePath || image.url">
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <div class="button-wrapper">
      <button
        type="button"
        class="btn btn-secondary"
        @click="onPrevStep"
      >
        GERİ DÖN
      </button>
      <button
        type="button"
        class="btn btn-trendyol"
        @click="onNextStep"
      >
        DEVAM ET
      </button>
    </div>

    <ModalMediaGallery
      :show="showMediaGallery"
      @close="closeMediaGallery"
      @onSelect="selectMediaGallery"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Step from './Components/Step';
import ModalMediaGallery from './Modals/ModalMediaGallery';
import message from '@/utils/message';

const maxAllowedSize = 10 * 1024 * 1024;
export default {
  name: 'ProductImage',
  components: { ModalMediaGallery, Step },
  data () {
    return {
      showMediaGallery: false,
      formData: {},
      eventList: {
        camera: {
          value: false,
          e: {
            eventCategory: 'MobileAppListing',
            eventAction: 'ÜrünListesiDropdownMenüAçanlar',
            eventLabel: 'ÜrünListesiDropdownMenüTekilÜrünEklemeKameraAçılması',
          },
        },
        gallery: {
          value: false,
          e: {
            eventCategory: 'MobileAppListing',
            eventAction: 'ÜrünListesiDropdownMenüAçanlar',
            eventLabel: 'ÜrünListesiDropdownMenüTekilÜrünEklemeTelefonGalerisi',
          },
        },
        mediaGallery: {
          value: false,
          e: {
            eventCategory: 'MobileAppListing',
            eventAction: 'ÜrünListesiDropdownMenüAçanlar',
            eventLabel: 'ÜrünListesiDropdownMenüTekilÜrünEklemeTrendyolGalerisi',
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      getFiles: 'mediaCenter/getFiles',
      getFormData: 'singleProduct/getFormData',
    }),
    hasImagesInGallery () {
      return this.getFiles.length > 0;
    },
    getProductImages () {
      return this.formData.productImages.map(item => {
        if (item.url && item.url.indexOf('?') > -1) {
          const thumbnailUrl = item.url.split('?')[0];
          item.url = `${thumbnailUrl}?x-oss-process=image/resize,w_500,limit_0`;
        }

        return item;
      });
    },
  },
  beforeDestroy () {
    this.handleEvents();
  },
  methods: {
    ...mapActions({
      getAllFiles: 'mediaCenter/getAllFiles',
      createProductBarcodeBulk: 'singleProduct/createProductBarcodeBulk',
      setFormData: 'singleProduct/setFormData',
    }),
    async validate () {
      if (this.getProductImages.length > 8) {
        message.error('Barkodunuza maksimum 8 adet fotoğraf ekleyebilirsiniz!');
        return false;
      }

      this.setFormData(this.formData);
      return true;
    },
    selectMediaGallery (files, id) {
      this.formData.productImages = [
        ...this.formData.productImages,
        ...files,
      ];

      switch (id) {
        case 'camera':
          this.eventList[id].value = true;
          break;
        case 'gallery':
          this.eventList[id].value = true;
          break;
        default:
          this.eventList.mediaGallery.value = true;
          break;
      }
    },
    onChangeImages (e) {
      let sizeCheck = false;
      const id = e.target.id;
      const files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        files.forEach(file => {
          if (file.size > maxAllowedSize) {
            sizeCheck = true;
          }
        });

        if (sizeCheck) {
          message.warning('Maksimum yükleyeceğiniz dosya boyutu 10MB olmalıdır.');
        } else {
          const images = [...files].map(im => {
            im.filePath = URL.createObjectURL(im);
            return im;
          });
          this.selectMediaGallery(images, id);
        }
      }
    },
    onInputFile () {
      this.$refs.fileInput.click();
    },
    onInputCamera () {
      this.$refs.fileCamera.click();
    },
    handleEvents () {
      // eslint-disable-next-line no-unused-vars
      for (const [_, item] of Object.entries(this.eventList)) {
        if (item.value) {
          this.$root.trackEvent(item.e);
        }
      }
    },
    openMediaGallery () {
      this.showMediaGallery = true;
    },
    closeMediaGallery () {
      this.showMediaGallery = false;
    },
    removeProductImage (i) {
      this.formData.productImages.splice(i, 1);
    },
    onPrevStep () {
      this.$router.push({
        name: 'ProductProperty',
      });
    },
    async onNextStep () {
      const isValid = await this.validate();
      if (isValid) {
        const query = {};
        if (this.formData.productVarianters.length <= 1) {
          query.barcode = this.formData.productVarianters[0].barcode;
        }

        this.createProductBarcodeBulk(() => {
          this.$router.push({
            name: 'ProductComplete',
            query,
          });
        });
      }
    },
  },
  async created () {
    this.formData = this.getFormData;
    this.getAllFiles();
  },
};
</script>

<style lang="scss" scoped>
  section .btn {
    padding-left: 15px;
    padding-right: 15px;
    text-align: left;
    display: flex;
    align-items: center;
    span {
      display: block;
      flex: 1;
    }
    img + span {
      padding: 0 15px;
    }
    .fileInput {
      position: absolute;
      z-index: -99999;
      display: none;
    }
  }
  .text-info {
    font-size: 80%;
    color: #273142;
    margin-bottom: 20px;
  }

  .uploaded-wrapper {
    overflow: hidden;
    overflow-x: auto;
    width: 100%;
    padding-bottom: 10px;
    .images {
      display: flex;
      flex-wrap: nowrap;
      list-style: none;
      margin: 0;
      padding: 0;
      .image {
        height: 130px;
        max-width: 95px;
        min-width: 95px;
        padding: 0 5px;
        display: flex;
        align-items: center;
        .image-wrapper{
          border-radius: 6px;
          overflow: hidden;
          position: relative;
          width: 100%;
          height: 100%;
          border: 1px solid rgb(213, 217, 225);

          .close-container{
            position: absolute;
            z-index: 1;
            top: 5px;
            right: 5px;
            img {
              width: 12px;
            }
          }
        }
        img{
          width: 100%;
        }
      }
    }
  }
</style>
